import React, { useState } from "react";

const numberRelations = {
    1: { friend: [1, 2, 3, 5, 6, 9], neutral: [4, 7], enemy: [8] },
    2: { friend: [1, 2, 3, 5], neutral: [7, 6], enemy: [8, 4, 9] },
    3: { friend: [1, 2, 3, 5, 7], neutral: [4, 8, 9], enemy: [6] },
    4: { friend: [1, 5, 7, 6], neutral: [3], enemy: [2, 9] },
    5: { friend: [1, 2, 3, 5, 6], neutral: [4, 7, 8, 9], enemy: [] },
    6: { friend: [1, 4, 5, 6, 7], neutral: [2, 8, 9], enemy: [3] },
    7: { friend: [1, 3, 5, 4, 6], neutral: [2, 7, 8, 9], enemy: [] },
    8: { friend: [5, 3, 6, 7], neutral: [9], enemy: [1, 2] },
    9: { friend: [1, 3, 5], neutral: [7, 6, 8, 9], enemy: [4, 2] },
};

const reduceNumber = (value) => {
    let number = value;

    while (number > 9) {
        number = String(number)
            .split("")
            .reduce((sum, digit) => sum + Number(digit), 0);
    }

    return number;
};

const getMulank = (birthDate) => {
    const day = Number(birthDate.split("-")[2]);
    return reduceNumber(day);
};

const getDestiny = (birthDate) => {
    const total = birthDate
        .replace(/-/g, "")
        .split("")
        .reduce((sum, digit) => sum + Number(digit), 0);

    return reduceNumber(total);
};

const getReportNumbers = (mulank, destiny) => {
    const allNumbers = [1, 2, 3, 4, 5, 6, 7, 8, 9];
    const mulankRelations = numberRelations[mulank];
    const destinyRelations = numberRelations[destiny];

    if (!mulankRelations || !destinyRelations) {
        return { favorable: [], neutral: [], avoid: [] };
    }

    const favorable = mulankRelations.friend.filter((number) =>
        destinyRelations.friend.includes(number),
    );
    const avoid = [
        ...new Set([...mulankRelations.enemy, ...destinyRelations.enemy]),
    ];
    const neutral = allNumbers.filter(
        (number) => !favorable.includes(number) && !avoid.includes(number),
    );

    return { favorable, neutral, avoid };
};

export const LuckyNumber = () => {
    const [report, setReport] = useState(null);

    const handleSubmit = (event) => {
        event.preventDefault();
        const form = event.target;
        const name = form.elements.name.value;
        const birthDate = form.elements.birthDate.value;
        const mulank = getMulank(birthDate);
        const destiny = getDestiny(birthDate);
        const numbers = getReportNumbers(mulank, destiny);
        const usageDescription = `Use favorable numbers ${numbers.favorable.join(", ") || "with care"
            } for important dates, business decisions, names, and
      daily choices. Treat neutral numbers as flexible and avoid relying on
      numbers ${numbers.avoid.join(", ") || "none"} when you have a better option.`;
        setReport({
            name,
            birthDate,
            mulank,
            destiny,
            numbers,
            usageDescription,
        });
    };

    return (
        <div className="lucky-number-layout">
            <header className="lucky-number-header">
                <a href="/" aria-label="AstroSarathi home">
                    <img src="img/logo/logo.png" alt="AstroSarathi" />
                </a>
                <nav aria-label="Main navigation">
                    <a href="/#about">About</a>
                    <a href="/#services">Services</a>
                    <a href="/#contact">Contact</a>
                </nav>
            </header>

            <main className="lucky-number-page">
                <div className="lucky-number-panel">
                    <a className="lucky-number-back" href="/">
                        Back to home
                    </a>
                    <p className="lucky-number-eyebrow">AstroSarathi consultation</p>
                    <h1>Discover your lucky number</h1>
                    <p className="lucky-number-intro">
                        Share your details and we will connect with you for a personal
                        numerology interaction.
                    </p>
                    {report ? (
                        <div className="lucky-number-report" role="status">
                            <p className="lucky-number-eyebrow">Your number report</p>
                            <div className="lucky-number-summary">
                                <div>
                                    <span>Mulank</span>
                                    <strong>{report.mulank}</strong>
                                </div>
                                <div>
                                    <span>Destiny number</span>
                                    <strong>{report.destiny}</strong>
                                </div>
                            </div>
                            <div className="lucky-number-results">
                                <p>
                                    <strong>Favorable:</strong>{" "}
                                    {report.numbers.favorable.join(", ") || "None"}
                                </p>
                                <p>
                                    <strong>Neutral:</strong>{" "}
                                    {report.numbers.neutral.join(", ") || "None"}
                                </p>
                                <p>
                                    <strong>Consider avoiding:</strong>{" "}
                                    {report.numbers.avoid.join(", ") || "None"}
                                </p>
                                <p>
                                    <strong>How to use these numbers:</strong>{" "}
                                    {report.usageDescription}
                                </p>
                            </div>
                            <button
                                type="button"
                                className="lucky-number-reset"
                                onClick={() => setReport(null)}
                            >
                                Calculate again
                            </button>
                        </div>
                    ) : (
                        <form className="lucky-number-form" onSubmit={handleSubmit}>
                            <label htmlFor="customer-name">Full name</label>
                            <input id="customer-name" name="name" type="text" required />

                            <label htmlFor="customer-phone">Phone number</label>
                            <input id="customer-phone" name="phone" type="tel" required />

                            <label htmlFor="customer-birth-date">Date of birth</label>
                            <input
                                id="customer-birth-date"
                                name="birthDate"
                                type="date"
                                required
                            />

                            <label htmlFor="customer-message">
                                What would you like to know?
                            </label>
                            <textarea
                                id="customer-message"
                                name="message"
                                rows="4"
                                placeholder="Business, relationships..."
                            ></textarea>

                            <button type="submit">Request interaction</button>
                        </form>
                    )}
                </div>
            </main>

            <footer id="footer" className="lucky-number-footer">
                <div className="container text-center">
                    <p>
                        &copy; {new Date().getFullYear()} AstroSarathi. All rights reserved.
                    </p>
                </div>
            </footer>
        </div>
    );
};
